import request from '@/utils/request';
// 试卷列表
export function queryExampaperList(data :{[key: string]: any} = {}) {
    return request.post({
        url: 'contentapi/exampaper/query',
        data: {
          channel_source: 'pc',
          ...data,
        },
    });
}

// 套卷详情
export const queryMultiDetail = (data = {}) => {
    return request.get({
      url: 'basicapi/v1/pack/paper/list',
      data: {
        channel_source: 'pc',
        ...data,
      },
    });
}

// 我的试卷列表
export const queryMyPaperList = (data = {}) => {
    return request.get({
      url: 'performapi/v1/user/paper/list',
      data: {
        type: 1, // 1:我的试卷  2:浏览历史  3：下载记录 4：打印记录
        ...data,
      },
    });
}
// 浏览记录
export const queryMyViewHistoryList = (data = {}) => {
    return request.get({
      url: 'performapi/v1/user/paper/list',
      data: {
        type: 2, // 1:我的试卷  2:浏览历史  3：下载记录 4：打印记录
        ...data,
      },
    });
}
// 年级列表
export const queryGradeList = (data = {}) => {
    return request.post({
      url: 'appframe/v1/app/config/list',
      data,
    });
}
// 字典接口
export const queryDictionaryList = (data = {}) => {
    return request.post({
      url: 'contentapi/exampaper/dictionary',
      data,
    });
}

// 临期弹窗
export const queryPopConfig = (data = {}) => {
  return request.get({
    url: 'basicapi/v1/pop/config',
    data,
  });
}